<template>
    <div class="relative w-full overflow-hidden">
      <div class="flex transition-transform duration-500 ease-in-out" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
        <div v-for="(slide, index) in slides" :key="index" class="w-full flex-shrink-0">
          <img class="h-auto w-full object-cover" :src="slide.src" :alt="slide.alt">
        </div>
      </div>
      <button class="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 text-blue-700 hover:bg-gray-200 text-white px-4 py-2 rounded-full" @click="prevSlide">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button class="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 text-blue-700 hover:bg-gray-200 text-white px-4 py-2 rounded-full" @click="nextSlide">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        currentSlide: 0,
        slides: [
          { src: 'https://dummyimage.com/1920x800/cfcfcf/000.png', alt: 'Los mejores repuestos de refrigeración y linea blanca' }
        ],
      };
    },
    methods: {
      nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      },
      prevSlide() {
        this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      },
    },
  };
  </script>